import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE,
    Persistor,
    persistReducer,
    persistStore
} from 'redux-persist';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import accountReducer from '@/redux/slices/accountSlice';
import paymentReducer from '@/redux/slices/paymentSlice';
import notificationReducer from '@/redux/slices/notificationSlice';
import menuReducer from '@/redux/slices/menuSlice';

const persistConfig = {
    key: 'root',
    storage
};

const rootReducer = combineReducers({
    account: accountReducer,
    payment: paymentReducer,
    notification: notificationReducer,
    menu: menuReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
});

export const persistor: Persistor = persistStore(store);
export interface RootState extends ReturnType<typeof store.getState>, PersistPartial { }
export type AppDispatch = typeof store.dispatch;
